import React from "react";
import styled from "styled-components";
import Task from "./Task";
import {Droppable} from "react-beautiful-dnd";

const Column = ({column, tasks}) => {

    return (
        <Container>
            <Title>
                <img src={column.img} alt={column.title}/>
                <h3>{column.title} ({tasks.length})</h3>
            </Title>
            <Droppable droppableId={column.id}>
                {(provided, snapshot) => (
                    <TaskList
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        isDraggingOver={snapshot.isDraggingOver}>
                        {tasks.map((t, index) => (
                            <Task key={t?.id} index={index} task={t}/>
                        ))}
                        {provided.placeholder}
                    </TaskList>
                )}
            </Droppable>

        </Container>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  background-color: var(--color-grey-03);
  border-radius: 15px;
  padding-top: 1rem;
  overflow: auto;
  height: 30rem;
  
`

const Title = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items:center;
  justify-content: center;
  

  h3{
    font-weight: 700;
  }
`

const TaskList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  transition: background-color 0.5s ease-out;
  background-color: ${props => (props.isDraggingOver ? "var(--color-grey)" : "transparent")};
  flex-grow: 1;
  min-height: 100px;

`
export default Column